import script from "./SentGift.vue?vue&type=script&setup=true&lang=js"
export * from "./SentGift.vue?vue&type=script&setup=true&lang=js"

import "./SentGift.vue?vue&type=style&index=0&id=1bfd4bf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bfd4bf0"]])

export default __exports__